export const USER_ROLES = {
    CAN_MANAGE_TENDER_CONFIG: 'CanManage_TenderConfiguration',
} as const;